import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { BreadcrumbJsonLd } from 'next-seo'
import getConfig from 'next/config'
import Hyperlink from '../HyperLink'
import SvgIcon from '../SvgIcon'
import DynamicItems from './DynamicItems'

const Breadcrumb = ({ items }) => {
  const isHome = items[0]?.label.toLowerCase() === 'home'

  const basePath =
    getConfig().publicRuntimeConfig?.APP_BASE_PATH ||
    'https://www.freedomdebtrelief.com'

  const breadcrumbsLd = useMemo(() => {
    const result = items.map((item, index) => {
      const path = item.path.startsWith('/')
        ? item.path.slice(1, item.path.length)
        : item.path

      return {
        item: `${basePath}/${path}`,
        name: item.label,
        position: isHome ? index + 1 : index + 2,
      }
    })

    if (!isHome) {
      result.unshift({
        item: `${basePath}/`,
        name: 'Home',
        position: 1,
      })
    }

    return result
  }, [basePath, isHome, items])

  return (
    <>
      {items.length > 0 ? (
        <BreadcrumbJsonLd itemListElements={breadcrumbsLd} />
      ) : null}
      <ol
        className="flex text-xs font-medium tracking-vast lg:text-sm"
        data-testid="breadcrumb"
      >
        <li
          className={`mr-5 inline-flex after:my-auto lg:mr-0 lg:after:ml-5 lg:after:content-['>']`}
        >
          <Hyperlink
            aria-label="Home link"
            href="/"
            childrenClassNames="my-auto"
            data-testid="breadcrumb-home"
            clickTracking={false}
          >
            <SvgIcon
              name="home"
              className="h-5 w-5 fill-blue-base text-base lg:hidden"
            />
            <p
              data-testid="home-breadcrumb-item"
              className="hidden tracking-[.2em] lg:block"
            >
              FREEDOM DEBT RELIEF
            </p>
          </Hyperlink>
        </li>
        <DynamicItems items={items} />
      </ol>
    </>
  )
}

Breadcrumb.propTypes = {
  items: PropTypes.array.isRequired,
}

export default React.memo(Breadcrumb)
